
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const CompassIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M68.6919 34.4349C70.7003 29.9162 66.083 25.2988 61.5642 27.3072L39.755 37.0001C38.5185 37.5497 37.5333 38.5435 36.9946 39.7848L27.7056 61.1871C25.7552 65.6808 30.315 70.2408 34.8088 68.2908L56.215 59.0017C57.4564 58.463 58.4503 57.4778 59 56.2412L68.6919 34.4349ZM43.1676 43.1436L60.6056 35.3934L52.8565 52.8284L35.7407 60.2557L43.1676 43.1436Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M68.6919 34.4349C70.7003 29.9162 66.083 25.2988 61.5642 27.3072L39.755 37.0001C38.5185 37.5497 37.5333 38.5435 36.9946 39.7848L27.7056 61.1871C25.7552 65.6808 30.315 70.2408 34.8088 68.2908L56.215 59.0017C57.4564 58.463 58.4503 57.4778 59 56.2412L68.6919 34.4349ZM43.1676 43.1436L60.6056 35.3934L52.8565 52.8284L35.7407 60.2557L43.1676 43.1436Z" fill="#161617"/>
<path fillRule="evenodd" clipRule="evenodd" d="M48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8ZM15 48C15 29.7746 29.7746 15 48 15C66.2254 15 81 29.7746 81 48C81 66.2254 66.2254 81 48 81C29.7746 81 15 66.2254 15 48Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M84.5 48C84.5 68.1584 68.1584 84.5 48 84.5C27.8416 84.5 11.5 68.1584 11.5 48C11.5 27.8416 27.8416 11.5 48 11.5C68.1584 11.5 84.5 27.8416 84.5 48Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
